import HostedReportModal from './HostedReportModal'

export default HostedReportModal
